import { IPPersonaPresence } from "baseComponents/Persona/IPPersona";

export default class Presence {
  availability: string;

  isOutOfOffice: boolean;

  constructor(availability: string, isOutOfOffice: boolean = false) {
    this.availability = availability;
    this.isOutOfOffice = isOutOfOffice;
  }

  getPersonaPresenceFromAvailability(availability: string = this.availability): IPPersonaPresence {
    switch (availability) {
      case 'Busy':
      case 'BusyIdle':
        return IPPersonaPresence.busy;

      case 'Available':
      case 'AvailableIdle':
        return IPPersonaPresence.online;

      case 'Away':
      case 'BeRightBack':
        return IPPersonaPresence.away;

      case 'Offline':
        return IPPersonaPresence.offline;

      case 'DoNotDisturb':
        return IPPersonaPresence.dnd;

      default:
        return IPPersonaPresence.none;
    }
  }
}
